import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import eventsEN from '../events/events_EN.json';
import eventsRU from '../events/events_RU.json';

export default function Events() {
  const { strings, lang_code } = useLanguage();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    // Select the correct language file
    const eventData = strings.lang_code === 'RU' ? eventsRU : eventsEN;
    
    // Sort by date in reverse chronological order (newest first)
    const sorted = [...eventData.events].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    );
    
    setEvents(sorted);
  }, [strings.lang_code]);

  return (
    <div className="content-wrapper">
      {events.map((event) => (
        <div key={event.id} className={`event event-${event.type}`}>
          <img src={event.image} alt={event.title} />
          <h3>{event.title}</h3>
          <p>{event.description}</p>
          <p><strong>Date:</strong> {event.date}</p>
          <p><strong>Location:</strong> {event.location}</p>
          <p><strong>Duration:</strong> {event.duration}</p>
          <p><strong>Time:</strong> {event.time}</p>
          <a href={event.link}>{event.cta}</a>
        </div>
      ))}
    </div>
  );
}

